import { createCtx } from 'src/utils/contextState'

export const [
  GenerationSelectableDialogContext,
  GenerationSelectableDialogContextProvider,
] = createCtx<GenerationSearchableDialogContextStateType>({
  openSearch: false,
})

export type GenerationSearchableDialogContextStateType = {
  /**
   * Mobile only
   */
  openSearch: boolean
}
